import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-grant-summary',
  standalone: false,
  templateUrl: './grant-summary.component.html',
  styleUrls: ['./grant-summary.component.scss']
})
export class GrantSummaryComponent implements OnInit, OnChanges {
  @Input() totalApproved: number = 0;
  @Input() totalSpent: number = 0;
  @Input() totalPending: number = 0;
  @Input() loading: boolean = false;
  
  // Add scheme-wise data inputs
  @Input() schemeWiseApproved: any = {};
  @Input() schemeWiseSpent: any = {};
  @Input() schemeWisePending: any = {};

  grantCards: any[] = [];

  ngOnInit(): void {
    this.updateCards();
  }

  ngOnChanges(): void {
    this.updateCards();
  }

  private updateCards(): void {
    this.grantCards = [
      {
        label: 'Total Grants Approved',
        count: this.totalApproved,
        icon: 'pi pi-check-circle',
        iconColor: '#10B981',
        bgColor: '#D1FAE5',
        borderColor: '#10B981',
        // Scheme breakdown
        schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseApproved, 'approved')
      },
      {
        label: 'Total Grants Spent',
        count: this.totalSpent,
        icon: 'pi pi-dollar',
        iconColor: '#3B82F6',
        bgColor: '#DBEAFE',
        borderColor: '#3B82F6',
        schemeBreakdown: this.getSchemeBreakdown(this.schemeWiseSpent, 'spent')
      },
      {
        label: 'Total Grants Pending',
        count: this.totalPending,
        icon: 'pi pi-clock',
        iconColor: '#F59E0B',
        bgColor: '#FEF3C7',
        borderColor: '#F59E0B',
        schemeBreakdown: this.getSchemeBreakdown(this.schemeWisePending, 'pending')
      },
    ];
  }

  // Helper method to create scheme breakdown array
  private getSchemeBreakdown(schemeData: any, type: string): any[] {
    if (!schemeData || Object.keys(schemeData).length === 0) {
      return [];
    }
    
    // Define the order of schemes (IFJ, IDEX DISC, ADITI, OPEN)
    // Adjust this based on your actual scheme names
    const schemeOrder = ['Fauji', 'DISC', 'OC', 'ADITI'];
    
    return schemeOrder.map(scheme => ({
      schemeName: scheme,
      count: schemeData[scheme] || 0,
      // Different colors for each scheme
      color: this.getSchemeColor(scheme)
    }));
  }

  // Assign different colors to each scheme
  private getSchemeColor(scheme: string): string {
    switch(scheme) {
      case 'Fauji':
        return '#EF4444'; // Red
      case 'DISC':
        return '#3B82F6'; // Blue
      case 'OC':
        return '#10B981'; // Green
      case 'ADITI':
        return '#8B5CF6'; // Purple
      default:
        return '#6B7280'; // Gray
    }
  }
}